<template>
  <nuxt-layout name="common" :theme="theme">
    <PageRoot v-if="!error" />
    <ErrorRouter v-else :error="error" />
  </nuxt-layout>
</template>
<script lang="ts" setup>
definePageMeta({
  middleware: ['marine-redirect-welcome'],
});

const error = ref();
let categoryPage: UseCategoryPage;

const { $sentryCaptureException } = useNuxtApp();

const route = useRoute();

const { section } = route.params;

let contextType: CategoryPageContextTypes;

switch (section) {
  case Sections.ChildForYou:
    contextType = CategoryPageContextTypes.AssessmentRun;
    break;
  default:
    contextType = CategoryPageContextTypes.Classic;
    break;
}

try {
  categoryPage = await useCategoryPage(contextType);
  provide(INJECT_CATEGORY_PAGE, categoryPage);
} catch (e) {
  globalThis.$logger.error('Page lb error ::', e);
  error.value = e;
  $sentryCaptureException(e);
}

const theme = computed(() => {
  if (error.value) return 'default';
  return categoryPage.categoryManager.category.value.contentType === 'adventure'
    ? 'adventure'
    : 'default';
});

onUnmounted(() => {
  if (categoryPage) {
    categoryPage.release();
  }
});
</script>
